import { useState } from 'react';
import React from 'react';
import { Chip, Box } from '@mui/material';

// const ITEM_HEIGHT = 60;
// const ITEM_PADDING_TOP = 10;
// const MenuProps = {
//   PaperProps: {
//     style: {
//       maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//       width: 250
//     }
//   }
// };

const names = ['Detections', 'Dock Utilizations', 'Camera'];

export default function MultipleSelectCheckmarks({ graphToSelect }) {
  const [selected, setSelected] = useState('Detections');

  const handleSelect = (name) => {
    if (name === 'Engagement') return; // Disable selection for 'Engagement'
    setSelected(name);
    graphToSelect(name);
  };

  return (
    <Box
      className="scrollbar"
      sx={{
        display: 'flex',
        gap: 1,
        overflowX: 'auto',
        whiteSpace: 'nowrap',
        p: 1,
        width: '100%'
      }}
    >
      {names.map((name) => (
        <Chip
          key={name}
          label={name}
          onClick={() => handleSelect(name)}
          sx={{
            borderRadius: '20px',
            px: 1.5,
            marginTop: '2px',
            backgroundColor: selected === name ? '#44BE54' : '#f0f0f0',
            color: selected === name ? '#fff' : '#000',
            opacity: name === 'Engagement' ? 0.6 : 1,
            transition: 'background-color 0.2s ease-in-out',
            '&:hover': {
              backgroundColor: selected === name ? '#329242' : '#e0e0e0'
            }
          }}
        />
      ))}
    </Box>
  );
}
